import { networkService as network } from '@/services'

export const userRoleService = {
  getUserRoles(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/user-roles/all/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getRole(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/roles/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  updateUserRole({ user, role }) {
    return new Promise((resolve, reject) => {
      const request = { user, role }
      network
        .put('/user-roles', request)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}